<script setup>
import { useVModel } from "@vueuse/core";
import { cn } from "@/lib/utils";

const props = defineProps({
  class: [String, Array, Object],
  defaultValue: [String, Number],
  modelValue: [String, Number],
  readonly: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(["update:modelValue"]);

const modelValue = useVModel(props, "modelValue", emits, {
  passive: true,
  defaultValue: props.defaultValue,
});
</script>

<template>
  <textarea
    v-model="modelValue"
    :readonly="readonly"
    :disabled="disabled"
    :class="
      cn(
        'vf-flex vf-w-full vf-rounded-md vf-border vf-border-input vf-bg-background vf-px-3 vf-py-2',
        'vf-text-sm placeholder:vf-text-muted-foreground focus-visible:vf-outline-none',
        'focus-visible:vf-ring-2 focus-visible:vf-ring-primary-400 focus-visible:vf-ring-offset-2 disabled:vf-cursor-not-allowed disabled:vf-opacity-50',
        props.class
      )
    "
  />
</template>
